import React, { useEffect, useState, useCallback } from 'react';
import { Redux, Slices } from 'spwa-ui-library';
import { Snackbar } from '@material-ui/core';
import ClassNames from 'classnames';
import { generateProductRoute } from 'spwa-ui-library/esm/utils/path';
import Alert from '@material-ui/lab/Alert';
import { addToCartGA, trackingAddedToCartGA } from 'spwa-ui-library/esm/utils/helperGA';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import Skeleton from 'react-loading-skeleton';
import { useIntl } from 'react-intl';
import NoProduct from './NoProduct';
import ProductTile from '../ProductTile';
import css from './index.module.scss';
import { useLocation, useNavigate } from '@reach/router';
import ProductCustomizationDialog from './ProductCustomizationDialog';
import BundleGroupDialog from './BundleGroupDialog';
import CartSkelton from '../../containers/Cart/CartSkelton';

const { useSelector, useDispatch } = Redux;
const {
  selectProductEntities,
  fetchProductsByCategoryId,
  selectProductFetchStatus,
  selectProductListByCat,
  getProductInfo,
  addNewProduct,
} = Slices.productSlice;
const { selectCartStatus, sendLocalCart, updateWithIndex } = Slices.cartSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const {
  fetchCategoryStatus,
  setCurrentCat,
  currentCategory,
  getCategoryProducts,
  selectCategoryById,
} = Slices.categorySlice;
const { getClusterId, selectCountryValidations } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { addProductToCustomize, updateProductPayload } = Slices.tempCartSlice;
const { selectPreviouslyOrderedProducts } = Slices.orderSlice;

export default function ProductTileList({
  searchResult,
  selectedCategoryTag = '',
  setPageLoader,
  category = {},
  className,
  setOpenSearch,
  shouldShowErrorMessage,
  categoryID,
}) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const locationSearch = new URLSearchParams(location.search);
  const productsMap = useSelector(selectProductEntities);
  // const cart = useSelector(cartItems);
  const cartState = useSelector(selectCartStatus);
  const fav = useSelector((state) => state.favourite);
  const temp = useSelector((state) => state.tempCart);
  const cart = useSelector((state) => state.cart);
  const allCategory = useSelector((state) => state.category);
  const bogoProducts = useSelector((state) => state.product.bogoProdList);
  const getCategory = useSelector((state) => selectCategoryById(state, categoryID));
  // const menu = useSelector(selectFirstMenu);

  const previouslyOrderedProducts = useSelector(selectPreviouslyOrderedProducts);
  let previouslyOrderedProductsId = previouslyOrderedProducts;
  previouslyOrderedProductsId = previouslyOrderedProductsId.filter(
    (value, index) => previouslyOrderedProducts?.indexOf(value) === index
  );

  const categoryStatus = useSelector(fetchCategoryStatus);
  const productStatus = useSelector(selectProductFetchStatus);
  const selectedProdListByCat = useSelector(selectProductListByCat);
  const currentCatId = useSelector(currentCategory);
  const address = useSelector(selectDefaultAddress);
  const getCatProducts = useSelector((state) => getCategoryProducts(state, categoryID));
  const [open, setOpen] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [showBundleGroupDialog, setShowBundleGroupDialog] = useState(0);
  const [showCustomizeProductDialog, setShowCustomizeProductDialog] = useState(0);
  const currentCountry = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) =>
    selectCountryValidations(state, currentCountry)
  );
  const currency = countryValidations?.currency;

  if (shouldShowErrorMessage) {
    selectedCategoryTag = '';
  }

  // COUNTRY DEF TEMP MENU ID

  const clusterId = useSelector(getClusterId);

  // PRODUCT IMPRESSION VIA productListViewGA GA
  const productListViewGA = useCallback(() => {
    let items;
    // if (category.generatedPath == window.location.pathname) {
    items = getCatProducts?.map((item) => {
      let product = productsMap[item];
      if (!product) return '';
      return {
        item_name: product.name,
        item_id: product.id,
        price: product?.originalPrice,
        item_category: getCategory?.code || '',
        item_category2: '',
        item_variant: product.typeId,
        item_list_id: +categoryID,
        item_list_name: getCategory?.code || '',
        currency: currency,
        item_brand: 'PH',
      };
    });
    // } else {
    //   return;
    // }
    window.dataLayer.push({
      event: 'view_item_list',
      currency: currency,
      item_list_id: +categoryID,
      item_list_name: getCategory?.code || '',
      ecommerce: {
        items,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCatProducts, currency, productsMap]);

  // eslint:fix [] is added and quick fix is used

  const productImpressionViewGA = () => {
    // if (category.generatedPath === window.location.pathname) {
    var impressions =
      getCatProducts.map((item, i) => {
        const product = productsMap[item];
        if (product) {
          return {
            name: product?.name || '',
            id: product?.id || '',
            price: product?.originalPrice || '',
            category: getCategory?.code || '',
            variant: product?.typeId || '',
            position: i + 1 || '',
          };
        }
      }) || [];
    // } else {
    //   return;
    // }
    window.dataLayer.push({
      event: 'productImpression',
      eventCategory: 'productImpression',
      eventAction: 'ProductListingPage',
      eventLabel: '',
      ecommerce: {
        currencyCode: 'AED',
        impressions,
      },
    });
  };

  useEffect(() => {
    setTimeout(() => {
      const yHeightScroll = localStorage.getItem('yHeightScroll');
      if (yHeightScroll) {
        window.scrollBy(0, yHeightScroll);
        localStorage.removeItem('yHeightScroll');
      }
    }, 100);
  }, []);

  const favtCategory = category.id === 999 ? true : false;
  let itemList = favtCategory ? fav.data.items : getCatProducts;

  // add bogo and other hidden deals
  let subCategories = Object.values(allCategory?.entities || {}).filter(
    (categoryObj) => categoryObj?.parentId == categoryID
  );

  subCategories = subCategories.map((subCategory) => {
    let subCategoryVariants = Object.values(allCategory?.entities || {}).filter(
      (subCategortVariant) => subCategortVariant?.parentId == subCategory?.id
    );

    subCategoryVariants = JSON.parse(JSON.stringify(subCategoryVariants));
    let products = [];
    let variantsArray = [];
    for (let i = 0; i < subCategoryVariants?.length; i++) {
      const steps = [
        {
          aKey: 'PHD_AE_v20_7_22_359_10598_1',
          assets: [{}],
          clusterKey: 'PHD_AE_v20_7_22',
          compId: parseInt(subCategoryVariants[i]?.id) * 10 + 1,
          groupId: 'PHD_AE_v20_7_22_359_10598',
          id: parseInt(subCategoryVariants[i]?.id) * 10 + 1,
          ingredient: 0,
          isAddon: 0,
          isDependent: 0,
          isHidden: 0,
          isModifier: 0,
          maximum: 1,
          minimum: 1,
          options: bogoProducts[subCategoryVariants[i]?.id],
          sCustomize: 1,
          subtitle: intl.formatMessage({ id: 'select_first_pizza' }),
          title: intl.formatMessage({ id: 'select_first_pizza' }),
          type: 'radio',
        },
        {
          aKey: 'PHD_AE_v20_7_22_359_10598_1',
          assets: [{}],
          clusterKey: 'PHD_AE_v20_7_22',
          compId: parseInt(subCategoryVariants[i]?.id) * 10 + 2,
          groupId: 'PHD_AE_v20_7_22_359_10598',
          id: parseInt(subCategoryVariants[i]?.id) * 10 + 2,
          ingredient: 0,
          isAddon: 0,
          isDependent: 0,
          isHidden: 0,
          isModifier: 0,
          maximum: 1,
          minimum: 1,
          options: bogoProducts[subCategoryVariants[i]?.id],
          sCustomize: 1,
          subtitle: intl.formatMessage({ id: 'select_second_pizza' }),
          title: intl.formatMessage({ id: 'select_second_pizza' }),
          type: 'radio',
        },
      ];

      variantsArray.push({
        isSelected: 0,
        title: subCategoryVariants[i]['name'],
        description: subCategoryVariants[i]['description'],
        id: subCategoryVariants[i]['id'],
      });

      products = products.concat({
        ...subCategoryVariants[i],
        sel1Value: subCategoryVariants[i]['id'],
        steps: steps,
        isHiddenDeal: true,
        isBOGO: true,
      });
    }
    const productStructure = {
      ...subCategory,
      categories: [subCategory?.parentId],
      variants: [
        {
          position: 1,
          orientation: 'vertical',
          id: 9999,
          selIndex: 1,
          title: intl.formatMessage({ id: 'please_choose_deal_size' }),
          subtitle: intl.formatMessage({ id: 'please_choose_deal_size' }),
          options: variantsArray,
        },
      ],
      items: products,
      bundleTypeId: 'bundle_group',
      typeId: 'bundle_group',
      isHiddenDeal: true,
      isBOGO: true,
    };

    if (
      (!productsMap[subCategory?.id] ||
        productStructure?.items?.[0]?.steps?.[0?.options?.length]) &&
      products.length
    ) {
      dispatch(addNewProduct(productStructure));
    }
    return productStructure;
  });

  if (!favtCategory) {
    itemList = Array.isArray(itemList)
      ? [...subCategories.map((sc) => sc.id), ...itemList]
      : [...subCategories.map((sc) => sc.id)];
  } else {
    itemList = itemList.filter((item) => {
      return productsMap[item]?.id;
    });
  }

  // useEffect(() => {
  //   if (
  //     category.generatedPath === window.location.pathname &&
  //     categoryStatus === 'succeeded' &&
  //     productStatus !== 'succeeded' &&
  //     !favtCategory
  //   ) {
  //     // eslint-disable-next-line no-extra-boolean-cast
  //     if (!!category.id) {
  //       dispatch(setCurrentCat(category.id));
  //     }
  //     if (!selectedProdListByCat[currentCatId]?.length) {
  //       dispatch(
  //         fetchProductsByCategoryId({
  //           id: category.id,
  //           cluster: clusterId,
  //           Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
  //           service: address.addressSubType || 'DELIVERY',
  //         })
  //       );
  //     }
  //   }
  // }, [
  //   address.addressSubType,
  //   category.generatedPath,
  //   category.id,
  //   categoryStatus,
  //   clusterId,
  //   currentCatId,
  //   dispatch,
  //   favtCategory,
  //   intl.locale,
  //   productStatus,
  //   selectedProdListByCat,
  // ]);

  const addtoCart = (prod, mapKey) => {
    setPageLoader(true);
    console.log(`prod -- `, prod);
    // check for variants in tempCart/customization
    const productVariationObject = temp.customize.items?.findLast((item) => item.id == prod.id);
    let specialPrice = productVariationObject?.price || prod?.specialPrice || prod?.originalPrice;

    if (productsMap[prod.id]?.items) {
      let variationArray = [-1, -1, -1];
      Object.values(productVariationObject?.variants || {}).forEach((variant, index) => {
        variationArray[index] = variant;
      });

      let variationItem = productsMap[prod.id]?.items?.find((item, index) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }
        let isVariantSame = true;
        variationArray.forEach((variant, index) => {
          if (itemInfo[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });

      if (variationItem && !variationItem?.id) {
        variationItem = productsMap[variationItem];
      }

      specialPrice = variationItem?.specialPrice || variationItem?.originalPrice || specialPrice;
    }

    let cartDefaultItemIndex = cart?.data?.items?.findIndex(
      (c) => c?.id == prod?.id && c.price == specialPrice && c.isDefault
    );

    if (cartDefaultItemIndex > -1) {
      let itemPayload = cart?.data?.items?.[cartDefaultItemIndex];
      let itemPerUnitPrice = (itemPayload?.price || 0) / (itemPayload?.qty || 1);
      dispatch(
        updateWithIndex({
          index: cartDefaultItemIndex,
          productPayload: {
            ...itemPayload,
            price: itemPerUnitPrice * ((itemPayload?.qty || 1) + 1),
            qty: (itemPayload?.qty || 1) + 1,
          },
        })
      );
    } else {
      if (productVariationObject?.id) {
        dispatch(
          updateProductPayload({
            data: productVariationObject,
          })
        );
      }

      dispatch(
        sendLocalCart({
          productType: prod.bundleTypeId,
          updatedOn: new Date().getTime(),
          mainProductId: prod.id,
          // data: { ...prod, items: productsMap[prod.id].items, category: category.id },
          data: {
            ...prod,
            items: null,
            specialPrice: specialPrice,
            category: category?.id == 999 ? prod?.categories?.[0] : category?.id,
          },
        })
      );
    }

    setTimeout(() => {
      setPageLoader(false);
    }, 0);
    addToCartGA(prod, currency, prod?.name || '', 'ProductListPage');
    trackingAddedToCartGA(prod, currency, category?.name || '', address);
    return cartState;
  };
  useEffect(() => {
    if (itemList.length) {
      productListViewGA();
      productImpressionViewGA();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // IF NO ITEMS FOUND
  if (!itemList?.length && !favtCategory) {
    return <CartSkelton />;
  }
  // IF NO ITEMS FOUND WITH  FAV ITEM
  if (!itemList?.length && favtCategory) {
    return <NoProduct favtCategory setOpenSearch={setOpenSearch} />;
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleBundleGroupAction = (optionId) => {
    setPageLoader(true);
    setShowBundleGroupDialog(0);
    let productRoute = generateProductRoute({
      product: productsMap[showBundleGroupDialog],
      category,
      locale: intl.locale.toLowerCase(),
    });
    productRoute = `${productRoute}/bundle?bundleGroup=1&option=${optionId}`;

    if (locationSearch.has('cartId')) {
      productRoute = `${productRoute}&cartId=${locationSearch.get('cartId')}`;
    }

    if (productsMap[showBundleGroupDialog]?.isHiddenDeal) {
      let productInfo =
        productsMap[optionId] ||
        productsMap[showBundleGroupDialog]?.items?.find((item) => item.id == optionId);
      navigate(productRoute, {
        state: {
          retUrl: window.location.pathname,
        },
      });
      dispatch(
        addProductToCustomize({
          productType: 'bundle',
          updatedOn: new Date().getTime(),
          mainProductId: productsMap[showBundleGroupDialog],
          data: {
            ...productInfo,
            id: showBundleGroupDialog,
            category: productsMap[showBundleGroupDialog]?.categories[0],
            noIncrement: true,
          },
        })
      );
    } else {
      dispatch(
        getProductInfo({
          id: showBundleGroupDialog,
          cluster: clusterId,
          service: address?.addressSubType || 'DELIVERY',
          categoryId: productsMap[showBundleGroupDialog]?.categories[0] || category?.id,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then((resp) => {
        let selectedProductItem = resp.payload?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          return itemInfo['sel1Value'] == optionId;
        });

        if (!selectedProductItem?.id) {
          selectedProductItem = productsMap[selectedProductItem];
        }

        dispatch(
          getProductInfo({
            id: selectedProductItem?.id,
            cluster: clusterId,
            service: address?.addressSubType || 'DELIVERY',
            categoryId: productsMap[selectedProductItem?.id]?.categories[0] || category?.id,
            Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
          })
        ).then((resp) => {
          navigate(productRoute, {
            state: {
              retUrl: window.location.pathname,
            },
          });
          let selectedBundle = productsMap[showBundleGroupDialog]?.items?.find((item) => {
            let itemInfo;
            if (item?.id) {
              itemInfo = item;
            } else {
              itemInfo = productsMap[item];
            }

            return itemInfo['sel1Value'] == optionId;
          });

          if (!selectedBundle?.id) {
            selectedBundle = productsMap[selectedBundle];
          }

          if (!selectedBundle?.steps?.[0]?.options) {
            selectedBundle = resp?.payload;
          }

          dispatch(
            addProductToCustomize({
              productType: 'bundle',
              updatedOn: new Date().getTime(),
              mainProductId: productsMap[showBundleGroupDialog],
              data: {
                ...selectedBundle,
                id: showBundleGroupDialog,
                selectedBundleId: selectedBundle?.id,
                category: productsMap[showBundleGroupDialog]?.categories[0],
                noIncrement: true,
              },
            })
          );
        });
      });
    }
  };

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          {errMsg}
        </Alert>
      </Snackbar>
      <div className={ClassNames(css.root, className)}>
        {getCatProducts && [...itemList, ...getCatProducts].length === 0 && (
          <Skeleton count={10} className={css.Skeleton} height={56} />
        )}
        {itemList &&
          itemList.length > 0 &&
          itemList.map((productItem, key) => {
            const proID = productItem;
            const product = productsMap[proID];

            // IF NO PRODUCT SELECTED
            if (!product) {
              return null;
            }

            let isPreviouslyOrdered = previouslyOrderedProductsId?.indexOf(product.id) > -1;

            if (product?.bundleTypeId == 'bundle_group') {
              let itemIds =
                product?.items?.map((item) => (item?.id ? parseInt(item.id) : parseInt(item))) ||
                [];
              if (previouslyOrderedProductsId.some((item) => itemIds.includes(parseInt(item)))) {
                isPreviouslyOrdered = true;
              }
            }

            // filter product according to category tag
            let isValidTag = false;
            if (!selectedCategoryTag) {
              isValidTag = true;
            } else {
              isValidTag =
                Array.isArray(product?.tags) &&
                product.tags.some((tag) => selectedCategoryTag === tag);
            }

            if (!isValidTag) return null;
            return (
              <ProductTile
                key={product?.name + key}
                category={getCategory || {}}
                isPreviouslyOrdered={isPreviouslyOrdered}
                totalItems={previouslyOrderedProducts.length}
                productOrderIndex={previouslyOrderedProductsId}
                setShowCustomizeProductDialog={setShowCustomizeProductDialog}
                setShowBundleGroupDialog={
                  product?.bundleTypeId == 'bundle_group' || product?.typeId == 'bundle_group'
                    ? setShowBundleGroupDialog
                    : null
                }
                onAddCart={addtoCart}
                productObj={product}
                position={'MainITEM' + key}
                priceTo={
                  product?.tempPrice
                    ? decimalChecker(product?.tempPrice || 0)
                    : decimalChecker(product?.originalPrice || 0)
                }
              />
            );
          })}
      </div>
      {shouldShowErrorMessage && <div className={css.overlay}></div>}
      {showCustomizeProductDialog > 0 && (
        <ProductCustomizationDialog
          setShowCustomizeProductDialog={setShowCustomizeProductDialog}
          showCustomizeProductDialog={showCustomizeProductDialog}
          setShowBundleGroupDialog={setShowBundleGroupDialog}
          oldLocation={JSON.parse(JSON.stringify(location))}
          returnURL={window.location.pathname}
        />
      )}

      {showBundleGroupDialog > 0 && (
        <BundleGroupDialog
          setShowBundleGroupDialog={setShowBundleGroupDialog}
          showBundleGroupDialog={showBundleGroupDialog}
          handleBundleGroupAction={handleBundleGroupAction}
        />
      )}
    </>
  );
}
